import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@6.0.11@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ib-task-review",
  "use": "icon-ib-task-review-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-ib-task-review\"><path d=\"M293.845333 263.765333a32 32 0 0 1 32-32h347.52a32 32 0 0 1 0 64H357.845333v432.469334h315.52a32 32 0 0 1 0 64H325.845333a32 32 0 0 1-32-32V263.765333z\" p-id=\"8309\" /><path d=\"M293.845333 512a32 32 0 0 1 32-32h347.52a32 32 0 0 1 0 64H325.845333a32 32 0 0 1-32-32z\" p-id=\"8310\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol